import {useMemo} from 'react';
import PropTypes from 'prop-types';
import {SelectEntity} from '@ozgene/gp5.components.select-entity';
import {findStatuses} from 'Sbs/service/SbsService';

const DEFAULT_STATUS = 'WIP';

export default function SelectSbsStatus(props) {
  const {
    value,
    id,
    placeholder,
    name,
    onChange,
    label,
    useDefault,

    ...restProps
  } = props;
  const getOptionLabel = (status) => status.status;
  const selectDefault = useMemo(
    () => (useDefault ? (status) => status.status === DEFAULT_STATUS : null),
    [useDefault],
  );

  return (
    <SelectEntity
      getEntities={findStatuses}
      value={value}
      onChange={onChange}
      selectDefault={selectDefault}
      label={label}
      getOptionLabel={getOptionLabel}
      placeholder={placeholder}
      {...restProps}
    />
  );
}

SelectSbsStatus.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.string.isRequired,
    status: PropTypes.string,
  }),
  id: PropTypes.string,
  name: PropTypes.string,
  useDefault: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};

SelectSbsStatus.defaultProps = {
  value: null,
  id: null,
  name: null,
  useDefault: false,
  label: 'SBS Status',
  placeholder: '',
};
